import React from 'react';
import { DogoLogo } from './DogoLogo';
export function HeroSection() {
  return <section id="home" className="min-h-screen flex items-center justify-center relative overflow-hidden text-center pt-[100px] pb-[60px] px-8 bg-[radial-gradient(ellipse_at_center,_#1a0000_0%,_#000000_70%)]" data-id="element-130">
      {/* Glowing pseudo-element equivalent */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[radial-gradient(circle,_rgba(224,0,0,0.08)_0%,_transparent_70%)] pointer-events-none" data-id="element-131"></div>

      <div className="relative z-10 flex flex-col items-center" data-id="element-132">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-[18px] mb-8" data-id="element-133">
          <DogoLogo size={80} className="w-[60px] h-[60px] sm:w-[80px] sm:h-[80px]" data-id="element-134" />
          <h1 className="text-[2.2rem] sm:text-[3.5rem] font-black tracking-[5px] sm:tracking-[8px] text-brand-text uppercase leading-none" data-id="element-135">
            DOGOSELL
          </h1>
        </div>

        <p className="text-[1rem] sm:text-[1.1rem] text-brand-muted tracking-[3px] uppercase mb-6" data-id="element-136">
          Your Global E-Commerce Platform
        </p>

        <div className="w-[60px] h-[3px] bg-brand-red mx-auto mb-8" data-id="element-137"></div>

        <p className="text-[0.95rem] sm:text-[1rem] text-brand-muted max-w-[500px] mx-auto mb-10 leading-relaxed" data-id="element-138">
          Connecting local businesses with consumers nationwide and worldwide.
          Quality products, seamless experience.
        </p>

        <a href="#about" className="inline-block px-10 py-3.5 bg-brand-red text-brand-text font-bold tracking-[2px] uppercase text-[0.85rem] transition-all duration-300 hover:bg-brand-darkRed hover:-translate-y-0.5 clip-parallelogram" data-id="element-139">
          Discover More
        </a>
      </div>
    </section>;
}